import { TruncatedTextTooltip } from '@components/Tooltip';
import { Counter } from '@utils';
import { useState } from 'react';

import { Overflow, Text } from './TruncatedText.styles';

interface ITruncatedText {
  children?: string;
  color?: string;
}

const TruncatedText = ({ children, color }: ITruncatedText) => {
  const ran = Counter.next();

  const [isOverflowed, setIsOverflowed] = useState(false);
  const tip = isOverflowed ? children : '';

  return (
    <>
      <Text data-tip={tip} data-for={`helpTruncatedContact${ran}`}>
        <Overflow onChange={setIsOverflowed} color={color}>
          {children}
        </Overflow>
      </Text>
      <TruncatedTextTooltip id={`helpTruncatedContact${ran}`} />
    </>
  );
};

export { TruncatedText };
